/* eslint-disable no-unused-vars */
import { useRef, useEffect, useMemo } from 'react';
import { Palette } from 'config';
import { Pen } from 'assets/icons';
import { CustomTooltip, IconButton, Loader } from 'components';
import { useSignal } from '@preact/signals-react';
import styled, { css } from 'styled-components';
import { BidTooltip } from './BidTooltip';

const bidType = {
  2: 'CPC:',
  3: 'CPI:',
  1: 'CPM',
};

export const Bid = (props) => {
  const { bid, bid_type, saved_min_bid, min_cpi, max_cpi, app_minCpi, campaignStatus } = props.data;

  const isOpenTooltip$ = useSignal(false);
  const btnRef = useRef();
  const handleClickOutside = (event) => {
    if (btnRef.current && btnRef.current.contains(event.target)) return;
    if (isOpenTooltip$.value && btnRef.current && !btnRef.current.contains(event.target)) {
      isOpenTooltip$.value = false;
    }
  };

  const isOnWheel = () => {
    isOpenTooltip$.value = false;
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    window.addEventListener('wheel', isOnWheel, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('wheel', isOnWheel, true);
    };
  }, [isOpenTooltip$.value]);

  const isDeletedCampaign = useMemo(() => {
    return campaignStatus === 9;
  }, [campaignStatus]);

  return (
    <Container>
      <Label>{bidType[bid_type]}</Label>
      <Value>${props.value}</Value>
      {!isDeletedCampaign && (
        <PenWrap>
          <CustomTooltip
            text={
              <BidTooltip
                ref={btnRef}
                bidValue={props.value}
                data={props.data}
                isOpen$={isOpenTooltip$}
              />
            }
            content={
              <IconButton.Micro
                icon={Pen}
                type={IconButton.btnTypes.tertiary}
                isPressed={isOpenTooltip$.value}
                onClick={() => (isOpenTooltip$.value = !isOpenTooltip$.value)}
              />
            }
            isOpen={isOpenTooltip$.value}
          />
        </PenWrap>
      )}
    </Container>
  );
};

const Container = styled.div`
  border-right: 1px solid ${Palette.PrimaryGray._200};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 4px;
  button {
    visibility: hidden;
  }
`;

const PenWrap = styled.div`
  width: 2px;
  overflow: visible;

  & > * {
    min-width: 18px;
  }
`;

const Text = styled.p`
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
`;

const Label = styled(Text)`
  color: ${Palette.PrimaryGray._500};
  text-align: center;
  font-weight: 400;
`;
const Value = styled(Text)`
  color: ${Palette.PrimaryGray._700};
  font-weight: 500;
`;
